//Using state for status bar so that if the bar is dismissed once, it remains dismissed across all pages
const statusBar = {
    namespaced: true,
    state: () => ({
        isVisible: true
    }),
    getters: {
        getIsVisible (state) {
            return state.isVisible;
        },
    },
    mutations: {
        SET_IS_VISIBLE: (state, isVisible) => {
            state.isVisible = isVisible
        }
    }
}

export default statusBar